import { render, staticRenderFns } from "./mailbox-verification-intro.vue?vue&type=template&id=3c5f91c7&"
import script from "./mailbox-verification-intro.vue?vue&type=script&lang=ts&"
export * from "./mailbox-verification-intro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports